import { useField } from "formik";
import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FormGroup, Label } from "reactstrap";

type CustomFormikDatePickerProps = {
  label: string;
  name: string;
  placeholder: string;
  filterDateHandler?: (date: Date) => boolean;
  disabled?: boolean;
  openToDate?: any;
  minSelectableDate?: any;
  maxSelectableDate?: any;
  onValueChange?: (date: Date | null) => void; // NEW  
  labelClassName?: string;
};

const NewCustomFormikDatePicker = ({
  label,
  name,
  disabled,
  openToDate,
  placeholder,
  onValueChange,
  minSelectableDate,
  maxSelectableDate,
  filterDateHandler,
  labelClassName = "",
}: CustomFormikDatePickerProps) => {
  const [field, meta, helpers] = useField(name);

  const handleChange = (date: Date | null) => {
    helpers.setValue(date);
    if (onValueChange) {
      onValueChange(date); // Trigger callback to revalidate related fields
      helpers.setTouched(true);
    }
  };

  return (
    <FormGroup className="">
      <Label className={`col-form-label ${labelClassName}`}>{label}</Label>
      <ReactDatePicker
        placeholderText={placeholder}
        className={`form-control f-12 d-block flatpickr-input ${
          meta.touched && meta.error ? "is-invalid" : ""
        }`}
        selected={field.value}
        onChange={handleChange}
        onBlur={() => helpers.setTouched(true)}
        filterDate={filterDateHandler}
        disabled={disabled}
        openToDate={openToDate}
        minDate={minSelectableDate}
        maxDate={maxSelectableDate}
      />
      {meta.touched && meta.error && (
        <div className="invalid-feedback d-block">{meta.error}</div>
      )}
    </FormGroup>
  );
};

export default NewCustomFormikDatePicker;
